import Marquee from "react-fast-marquee";

const items = [
  "Mindset",
  "Nutrition",
  "Exercise",
  "Optimal Health For Women Over 40",
];

export default function Ribbon() {
  return (
    <section data-testid="marquee" className="border-y border-border bg-linen py-8 md:py-10">
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic font-light text-4xl md:text-6xl text-plum px-8">
              {t}
            </span>
            <span className="text-gold text-2xl md:text-3xl">✳</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
